import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, InputRef, Modal, Space, Table, Tooltip, Upload, UploadProps, notification } from 'antd';
import {  checkAccess, concatenateRoleNames, getUserRole, rejectedApiMessage } from '../../utilities/CommonHelper';
import { fetchActiveUserbyAdmin, revokeByAdmin } from '../../store/reducers/userDashboardSlice';
import { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import Link from 'antd/es/typography/Link';
import CustomButton from '../../components/Buttons/Button';
import MultilineTextbox from '../../components/MultilineTextbox/MultilineTextbox';
import AuditLogModal from '../AuditlogModal/auditLogModal';
import InfoIcon from "../../assets/info_icon.svg";
import moment from 'moment';
import { getUserAccessData, getUserDetails } from '../../utilities/sessionHelper';
import { UploadOutlined, InfoCircleTwoTone } from '@ant-design/icons';
import { ColumnType, FilterConfirmProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

interface ActiveUserData {
  createdBy: string;
  createdDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  employeeId: string;
  email: string;
  name: string;
  businessUnit: string;
  department: string;
  reportingManagerName: string;
  reportingManagerEmail: string;
  employeeStatus: string;
  accessStatus: string;
  role: string;
}

type DataIndex = keyof ActiveUserData;

 
const ActiveUserTableContainer = (props:any) => {
  const dispatch = useDispatch();
  const userDashboardData = useSelector((state: any) => state.userDashboard);
  const [activeUserData, setActiveUserData] = React.useState<any>([]);
  const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";
  const user_email = getUserDetails()?.email;
  const [modalVisible, setModalVisible] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = React.useState<ActiveUserData | null>(null);
  const [rejectionReason, setRejectionReason] = React.useState('');
  const [file, setFile] = React.useState<File | null>(null);
  const [fileList, setFileList] = React.useState<any>([]);
  const [auditLogModalVisible, setAuditLogModalVisible] = useState(false);
  const [selectedemployeeData, setselectedemployeeData] = useState({});
  const [tabName, setTabName] = useState('');
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);
  const [filters, setFilters] = useState<any>([]);

  useEffect(() => {
    if(props.activeTab==='2'){
      fetchActiveUserbyAdminData(filters);
  }
  }, [pageNo,pageSize,props.activeTab]);

  useEffect(() => {
    setActiveUserData(Array.isArray(userDashboardData.activeUserList) ? userDashboardData.activeUserList : []);
  }, [userDashboardData.activeUserList]);


  const fetchActiveUserbyAdminData = (newFilters:any)=>{
    dispatch(fetchActiveUserbyAdmin({'page':pageNo,'size':pageSize,'filters':newFilters})).then((res: any) => {
          
      if (res.type !== 'request/fetchActiveUserbyAdmin/fulfilled') {
        rejectedApiMessage(res.payload);
      }else{
        setTotalCount(res.payload.totalElements);
    } 
    });
  }

  const updateFilters = (field: string, value: string, filters: any[]) => {
    const newFilters = [...filters];
    const index = newFilters.findIndex((filter) => filter.field === field);
    if (index > -1) {
      if (value === '' || value === null || value === undefined) {
        newFilters.splice(index, 1);
      } else
      {
        newFilters[index].value = value;
      }
    } else {
      newFilters.push({ 'field':field, 'value':value,'operator':'LIKE'});
    }
    setFilters(newFilters);
    dispatch(fetchActiveUserbyAdmin({'page':0,'size':pageSize,'filters':newFilters})).then((res: any) => {
          
      if (res.type !== 'request/fetchActiveUserbyAdmin/fulfilled') {
        rejectedApiMessage(res.payload);
      }else{
        setTotalCount(res.payload.totalElements);
        setPageNo(0);
    } 
    });
    
  }

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    updateFilters(dataIndex, selectedKeys[0],filters);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex] && record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const _activeUser_column: ColumnsType<ActiveUserData> = [
    {
      title: 'Employee Name',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Employee Email',
      dataIndex: 'email',
      key: 'email',
      width: 150,
      ...getColumnSearchProps('email'),
    },
    {
      title: 'Employee Id',
      dataIndex: 'employeeId',
      key: 'employeeId',
      width: 150,
      ...getColumnSearchProps('employeeId'),
    },
    {
      title: 'Business Unit',
      dataIndex: 'businessUnit',
      key: 'businessUnit',
      width: 150,
      ...getColumnSearchProps('businessUnit'),
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      width: 150,
      ...getColumnSearchProps('department'),
    },
    {
      title: 'Reporting Manager Name',
      dataIndex: 'reportingManagerName',
      key: 'reportingManagerName',
      width: 150,
      ...getColumnSearchProps('reportingManagerName'),
    },
    {
      title: 'Reporting Manager Email',
      dataIndex: 'reportingManagerEmail',
      key: 'reportingManagerEmail',
      width: 150,
      ...getColumnSearchProps('reportingManagerEmail'),
    },
    {
      title: 'Access Given On',
      dataIndex: 'accessUpdatedDate',
      key: 'accessUpdatedDate',
      width: 150,
      render: (text: string, record: any) => (
        <span>
          {record.accessUpdatedDate && moment(record.accessUpdatedDate.toString()).format('YYYY-MM-DD')}
        </span>
      ),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      width: 150,
      ...getColumnSearchProps('role'),
    },
    {
      title: 'History',
      dataIndex: 'History',
      key: 'history',
      width:100,
      fixed: 'right',
      render: (text: string, record: any) => (
        <>
          <Link onClick={() => handleHistory(record)}> <img src={InfoIcon} alt='info-icon' /></Link>
        </>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'Actions',
      key: 'Actions',
      width: 100,
      fixed: 'right',
      render: (text: string, record: any) => (
        <>
          <Link disabled={
            !checkAccess(role,"User Management",getUserAccessData()?.roleAccessMap[role],"write")
            ||(record.email===user_email && role==="Admin")
          }
           onClick={() => handleReject(record)}>Revoke</Link>
        </>
      ),
    },
  ];

  const handleReject = (record: ActiveUserData) => {
    setSelectedRecord(record);
    setModalVisible(true);
  };

  const handleModalOk = () => {
    if (!file) {
      notification.error({
        message: 'Error',
        description: 'Please select a file to upload',
      });
      return;
    }

    if (file.size > 500000) {
      notification.error({
        message: 'Error',
        description: 'File size should be less than 500KB',
      });
      return;
    }
      
    const allowedTypes = ['image/jpeg', 'image/png', 'image/png', 'application/vnd.ms-outlook'];
    const file_name=file.name;
    const file_type= file_name.substring(file_name.lastIndexOf('.') + 1);
    if (!allowedTypes.includes(file.type) && file_type!=='msg') {
      notification.error({
        message: 'Error',
        description: 'File type not supported. Please upload a JPG, PNG or MSG file',
      });
      return;
    }
    const reader = new FileReader();
    let base64String:string|undefined = '';
    reader.readAsDataURL(file);
    reader.onload=()=>{
          
        base64String = reader.result?.toString();
        const values = {
            empEmail: selectedRecord?.email,
            revokeReason: rejectionReason,
            file: base64String,
          };
      
          dispatch(revokeByAdmin(values)).then((response: any) => {
            
            if (response.type==='user/request/revokeByAdmin/fulfilled') {
              console.log('revokeByAdmin response', response);
              notification.success({
                message: 'Success',
                description: 'Request revoked successfully',
              });
              dispatch(fetchActiveUserbyAdmin({'page':pageNo,'size':pageSize})).then((res: any) => {
                if (res.type !== 'request/fetchActiveUserbyAdmin/fulfilled') {
                  rejectedApiMessage(res.payload);
                }else{
                  setTotalCount(response.payload.totalElements);
              } 
              } );
              console.log('Rejecting record:', selectedRecord, 'with reason:', rejectionReason);
              setModalVisible(false);
              setSelectedRecord(null);
              setRejectionReason('');
              setFile(null);
              setFileList([]);
            } else {
              rejectedApiMessage(response.payload);
            }
          });
    }
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setSelectedRecord(null);
    setRejectionReason('');
    setFile(null);
    setFileList([]);
  };

  const handleFileChange = (file: File| null) => {
    // if(file){
        setFile(file);
    // }

  };

  const handleHistory = (record: ActiveUserData) => {
    setselectedemployeeData(record);
    setTabName('activeUser');
    setAuditLogModalVisible(true);
  };

  const addKeyToObjects=(array:any)=> {
    return array.map((item:any, index:any) => ({ ...item, key: index }));
  }

  const handleAuditLogModalClose = () => {
    setAuditLogModalVisible(false);
    setselectedemployeeData({});
    setTabName('');
  }
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };
  const handleValidation=()=>{
    if(rejectionReason.trim().length===0 || !file){
      return true;
    }
    return false;
  }

  const _props: UploadProps = {
    onRemove: (file:any) => {
      setFile(file);
      setFileList([file]);
    },
    beforeUpload: (file) => {
      setFile(file);
      setFileList([file]);

      return false;
    },
    fileList,
  };

  return (
    <div className="containerr">
      <Table
       className="table-style" 
      dataSource={[...activeUserData]}
      // dataSource={[...activeUser_data]}
      loading={userDashboardData?.loading}
      rowKey={'email'} columns={_activeUser_column} 
      scroll={{ x: 'max-content', y: 350}}
      pagination={{
        current: pageNo + 1,
        pageSize,
        total: totalCount,
      }}
      onChange={handleTableChange} />
      <Modal
        title="Revoke Request"
        open={modalVisible}
        // onOk={handleModalOk}
        onCancel={handleModalCancel}
        closable={true}
        footer={() => {
          return (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CustomButton type="cancel" label="Cancel" onClick={handleModalCancel}></CustomButton>
              <CustomButton type="submit" label="Revoke" disabled={handleValidation()} onClick={handleModalOk}></CustomButton>
            </div>
          );
        }}
        styles={{
          content: {
            borderRadius: '0',
            borderTop: '4px solid #1677ff',
            font: 'normal normal normal 14px/20px Nunito Sans',
          },
        }}
      >
        <MultilineTextbox
          id="reason"
          label="Reason for Revoke"
          key="reasonForRevoke"
          placeholder="Enter reason for revoke"
          value={rejectionReason}
          width="200px"
          onChange={(id: string, newvalue: string, oldvalue: string | null) => setRejectionReason(newvalue)}
        />
        <div style={{display:'flex'}}>
        
          <Tooltip title={()=><>
          <span>File size must be less than 5MB</span><br/>
          <span>File format must be .jpg, .png, or .msg</span>
          </>}><InfoCircleTwoTone style={{alignItems:'flex-start', marginTop:'5px',marginRight:'10px'}}/></Tooltip> 
          <Upload maxCount={1} multiple={false} {..._props}>
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </div> 
        {/* <Upload label="Upload file" accept="image/png, image/jpeg, image/jpg" maxSize={500000} onChange={handleFileChange} /> */}
      </Modal>
      <AuditLogModal visible={auditLogModalVisible} onCancel={() => handleAuditLogModalClose()} selectedemployeeData={selectedemployeeData} tabName={tabName} />
    </div>
  );
};

export default ActiveUserTableContainer;